<template>
  <roe-error-message :field="design.employer_match_funding_frequency">
    <v-select
      v-model="design.$model.employer_match_funding_frequency"
      name="employer_match_funding_frequency"
      :options="selectOptions.funding_frequency"
      :reduce="label => label.code"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { mapGetters } from "vuex";

export default {
  name: "RoeEmployerMatchFundingFrequencySelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  computed: {
    ...mapGetters(["selectOptions"])
  }
};
</script>
